<template>
  <div class="ab-wrapper">
    <div class="banner-wrapper">
      <div class="ab-container">
        <div class="banner-word">
          <div class="ab-title banner-title wow fadeInDown">关于飞渡数字</div>
          <div class="banner-word-content wow bounceIn">
            <p>
              飞渡数字科技（杭州）有限公司是一家专注于楼宇、园区及开发区智能化建设的互联网公司。飞渡数字是余杭区政府2018年重点引进项目之一，囊括了物联网、BIM、园区楼宇管理、人工智能、大数据等多专业的技术人才。
            </p>
            <p>
              公司致力于通过物联网、BIM、人工智能及大数据等技术手段，以构建开发区及园区新的空间智慧生态为战略目标，为开发区及园区的空间运营提供智慧管理及服务平台，协助客户打通园区管理和园区服务全流程和全场景的数字化运营。我们助力客户提升空间运营效率，优化企业或产业服务品质，沉淀多维度数据，携手共筑开发区及园区的空间智慧生态。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="ab-main">
      <div class="ab-content founding-team">
        <div class="ab-container">
          <div class="ab-title-wrapper">
            <div class="ab-title animate__animated fadeInDown">创始团队</div>
          </div>
          <div>
            <ul class="clearfix">
              <li v-for="(item,index) in teamList" :key="index">
                <div class="desc">
                  <h2 class="wow animate__fadeInRight" data-wow-duration="1s">{{item.title}}</h2>
                  <h3 class="wow animate__fadeInRight" data-wow-duration="1.1s">{{item.subTitle}}</h3>
                  <div class="underline"></div>
                  <div class="info wow animate__fadeInRight" data-wow-duration="1.2s">
                    <p v-for="(text,textIndex) in item.desc" :key="textIndex">{{text}}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="ab-content" :class="{'ab-mission': !isMobileStatus}">
        <div class="ab-container">
          <div class="ab-title-wrapper">
            <div class="ab-title animate__animated fadeInDown">愿景与使命</div>
            <div class="ab-title-word">园区创新生态服务运营商</div>
            <div class="ab-title-desc">为政府、园区提供“咨询+技术+运营+生态”的全案能力。</div>
          </div>
          <div class="ab-option-wrapper" :class="{'ab-mb-option-wrapper': isMobileStatus}">
            <div class="ab-option-item wow bounceIn" v-for="(option,optionIndex) in optionItemList" :key="optionIndex">
              <template>
                <div class="ab-item-icon" v-if="optionIndex !== 1">
                  <div class="ab-item-number" v-if="isMobileStatus">{{ '0' + (optionIndex + 1) }}</div>
                  <img class="animate__animated" :src="option.icon" alt="">
                </div>
                <div class="ab-item-number" v-if="!isMobileStatus">{{ '0' + (optionIndex + 1) }}</div>
                <div class="ab-item-content">
                  <div class="ab-item-describe">{{ option.desc }}</div>
                  <div class="ab-item-text">{{ option.text }}</div>
                </div>
                <div class="ab-item-icon animate__animated" v-if="optionIndex === 1">
                  <img class="animate__animated" :src="option.icon" alt="">
                  <div class="ab-item-number" v-if="isMobileStatus">{{ '0' + (optionIndex + 1) }}</div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="ab-content">
        <div class="ab-container">
          <div class="ab-title-wrapper">
            <div class="ab-title animate__animated fadeInDown">资质和荣誉</div>
          </div>
          <div class="ab-carousel-wrapper">
            <el-carousel :type="isMobileStatus ? null : 'card'" trigger="click" indicator-position="none">
              <el-carousel-item v-for="(item,index) in honorList" :key="index">
                <p><el-image :src="item.url" :preview-src-list="honorList.map(pic => pic.url)" alt=""></el-image></p>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="ab-content ab-connect">
        <div class="ab-container">
          <div class="ab-title-wrapper">
            <div class="ab-title animate__animated fadeInDown">联系我们</div>
          </div>
          <div class="ab-connect-wrapper" :class="{'ab-mb-connect-wrapper': isMobileStatus}">
            <div class="connect-content">
              <p>联系电话：0571-86299105</p>
              <p>Email：datax@freedodata.com</p>
            </div>
            <div class="connect-content">
              <p>地址：杭州市临平区南苑街道麦道大厦1018室</p>
              <p>邮编：311199</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {pdList,pdListB,teamList} from './data';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      pdListB,
      teamList,
      optionItemList: [
        {
          icon: '/static/images/about/yj-icon1.png',
          desc: '洞悉产业运营，助力园区战略',
          text: '做到比园区更懂园区'
        },
        {
          icon: '/static/images/about/yj-icon2.png',
          desc: '长期服务伴随，持续园区优化',
          text: '成为园区的贴身管家'
        },
        {
          icon: '/static/images/about/yj-icon3.png',
          desc: '开放合作平台，促进园区成长',
          text: '优化园区的功能生态'
        }
      ],
      honorList:pdList,
    }
  },
  computed:{
    ...mapState({
      clientWidth: state => state.clientWidth,
      isMobile: state => state.isMobile,
    }),
    isPcStatus() {
      return this.clientWidth > 1044 && !this.isMobile;
    },
    isMobileStatus() {
      return this.clientWidth <= 750  && this.isMobile;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/aboutUs.scss';
</style>


// WEBPACK FOOTER //
// src/components/aboutUs/aboutUs.vue